import { jsxs as _jsxs } from "react/jsx-runtime";
import { getZombieInstanceFromPrimaryKey } from '@iotv/datamodel-core';
import { Link } from 'react-router-dom';
import { ContainerArbitrator } from '../../../../ArbitrationObjects/ContainerArbitrator/containerArbitrator';
const debug = process.env.REACT_APP_DEBUG && false;
/**
 * Wraps a hyperlink aound cell contents
 */
export const wrapLink = (to, cellRenderFn) => (p) => (_jsxs(Link, { to, children: [cellRenderFn?.(p) ?? p.formattedValue ?? p.value, " "] }));
/**
 * sets hyperlink to standard type/id structured url
 * cant be used on types where sk is compounded eg Incidents
 */
export const wrapLinkConstructorStd = (params, linkString = 'THINGVIEW', cellRenderFn) => {
    const vob = getZombieInstanceFromPrimaryKey(params.row['sk']);
    debug && console.log('wrapLinkConstructor vob', vob);
    const to = vob ? `/${linkString}/${vob.type}/${vob.id}` : undefined;
    return to ? wrapLink(to, cellRenderFn)(params) : cellRenderFn ? cellRenderFn(params) : (params.formattedValue ?? params.value);
};
export const wrapLinkConstructorPlain = (params, linkString, cellRenderFn) => {
    return linkString ? wrapLink(linkString, cellRenderFn)(params) : cellRenderFn ? cellRenderFn(params) : (params.formattedValue ?? params.value);
};
/**
 * Wraps a VOB in the link to it's canonical container page
 * Assumes row id or provided skKey is an sk of an object
 */
export const WrapLinkVOB = (params, skKey = 'id', cellRenderFn, linkFn) => {
    debug && console.log('wrapLinkVOB params', params);
    let link = undefined;
    if (linkFn) {
        link = linkFn(params.row);
    }
    const sk = params.row[skKey];
    const vob = sk ? getZombieInstanceFromPrimaryKey(params.row[skKey], { supportedType: params?.row?.supportedType }) : undefined;
    const canonicalLink = vob ? ContainerArbitrator.getCanonicalContainerLinkForObject({ vob }) : undefined;
    debug && vob && console.log(`Wrapping link for ${vob.type} with link: ${link}`);
    const to = link && vob ? `/${link}/${vob.type}/${vob.id}` : canonicalLink;
    return to ? wrapLink(to, cellRenderFn)(params) : cellRenderFn ? cellRenderFn(params) : (params.formattedValue ?? params.value);
};
